import { useRequest } from 'ahooks';

import useUpload from './use-upload';

interface UseBatchImportParams {
  importFile: (parmas: any) => Promise<any>;
}

export default function useBatchImport(params: UseBatchImportParams) {
  const {
    onSuccess,
    onError,
    onStart,
    ...dialogProps
  } = useUpload();
  const { runAsync, cancel: cancelFetch } = useRequest(params.importFile, {
    manual: true,
  });
  const batchImportButtonProps = {
    onSuccess,
    onError,
    uploadReq: runAsync,
  };
  const batchImportDialogProps = {
    rowKey: 'driver_id',
    ...dialogProps,
    cancelFetch,
  };

  return {
    batchImportButtonProps,
    batchImportDialogProps,
  };
}
